import { QUES_COMPONENT_TYPES } from '../componentTypes';

export default [
  {
    content:
      'Have there been any acquisitions or divestitures in the past 5 years?',
    subSection: 'Deal Experience',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [{ text: 'Yes' }, { text: 'No' }],
  },

  {
    content: 'How would you characterize the M&A transaction by deal type?',
    subSection: 'Deal Type',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [
      { text: 'Absorption' },
      { text: 'Tuck-in' },
      { text: 'Transformational' },
      { text: 'Stand-Alone' },
    ],
  },
  {
    content: 'What is the expected degree of integration?',
    subSection: 'Deal Type',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [{ text: 'Full' }, { text: 'Partial' }, { text: 'Stand-Alone' }],
  },
  {
    content:
      'What type of deal is being considered for the disposal of the business?',
    subSection: 'Deal Type',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [{ text: 'Wholly Acquired' }, { text: 'Carve-out' }],
  },
  {
    content: 'What types of operational diligence has been performed?',
    subContent: '[Select all that apply]',
    subSection: 'Integration Resources and Planning',
    type: QUES_COMPONENT_TYPES.CHECKBOX,
    cols: 2,
    options: [
      { text: 'Information Technology' },
      { text: 'Cybersecurity' },
      { text: 'HR' },
      { text: 'People & Org' },
      { text: 'Culture' },
      { text: 'Operations / Supply Chain' },
      { text: 'Sales and GTM' },
      { text: 'Products and Services' },
      { text: 'Financial' },
    ],
  },
  {
    content:
      'Which of the following components have / had a plan in place at signing (select all that apply)?',
    subSection: 'Integration Resources and Planning',
    type: QUES_COMPONENT_TYPES.CHECKBOX,
    options: [
      { text: 'Synergy plan' },
      { text: 'Integration strategy' },
      { text: 'Change management plan' },
      { text: 'Technology plan' },
      { text: 'Communications strategy' },
      { text: 'Personnel assessment' },
    ],
  },
  {
    content:
      'Does the Buyer company have a dedicated deal team to manage and assist in integration efforts?',
    subSection: 'Integration Resources and Planning',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [{ text: 'Yes' }, { text: 'No' }],
  },
];
